<template>
    <div id="clients-components-canceled">
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row ">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination
                                pills
                                align="fill"
                                :hide-goto-end-buttons="true"
                                :limit="3" v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <select class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Cliente)="{item}">
                                <span v-if="item.tipo_per==1">
                                    {{ item.nombre }} {{ item.paterno }} {{ item.materno }}
                                </span>
                                <span v-else> {{ item.nmComPerMoral }}</span>
                            </template>
                            <template #cell(Plan)="{item}">
                                 <span v-if="item.relpackage" class="badge rounded-pill text-bg-teal">
                                    {{ item.relpackage.paquete }}
                                 </span>
                            </template>
                            <template #cell(Paquete)="{item}">
                             <span v-if="item.relplanes" class="badge rounded-pill text-bg-purple">
                                 {{ item.relplanes.plan }}
                             </span>
                            </template>
                            <template #cell(Sku)="{item}">
                                {{ item.sku }}
                            </template>
                            <template #cell(Proceso)="{item}">
                                <span v-if="item.approved_at==''"
                                      class="badge rounded-pill text-bg-danger">Pendiente</span>
                                <span v-if="item.approved_at!=''&&item.canceled_at==''"
                                      class="badge rounded-pill text-bg-success">Contratado</span>
                                <span v-if="item.canceled_at!=''"
                                      class="badge rounded-pill text-bg-danger">Cancelado</span>
                            </template>
                            <template #cell(Agente)="{item}">
                            <span v-if="item.relagent">
                            {{ item.relagent.comisionista }}
                                </span>
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; restoreClient(item.id)">
                                            Restaurar
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Cargando...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                          v-model="pagination.current_page" :total-rows="pagination.total"
                                          :per-page="pagination.per_page" aria-controls="my-table"
                                          v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {clientsService} from "../../Services/Clients.service";

export default {
    name: "clients",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            person: false,
            filter: null,
            params: {
                limit: 10,
                page: 1,
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'Cliente'},
                {key: 'Plan'},
                {key: 'Paquete'},
                {key: 'Sku'},
                {key: 'Proceso'},
                {key: 'Agente'},
                {key: 'Acciones'}
            ],
            tituloBtn: 'Agregar',
            itemId: 0,
        }
    },
    methods: {
        async restoreClient(id) {
            let resp = await clientsService.restoreClient(id);
            this.getAlert(resp.process);
            await this.index();
        },

        async index() {
            this.isBusy = true;
            this.pagination = await clientsService.trashedClients(this.params);
            this.isBusy = false;
        },

        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },


    },
    mounted() {
        this.index();
    }
}
</script>
